import { RouterProvider } from 'react-router-dom';
import { router } from '@/router/router';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import LoadingOverlay from '@/components/LoadingOverlay';

function App() {
  const queryClient = new QueryClient();
  return (
    <>
      <LoadingOverlay />
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  );
}

export default App;
